import React from 'react';
import { observer } from 'mobx-react';
import { formatPriceDisplay } from 'Util/_HumanWritten/PriceFormattingUtils';
import { CartCalculationLineItem } from './CartCalculationLineItem';
import { IPriceLineItem } from 'Services/Api/_HumanWritten/PricingService/PricingResult';

export interface CreditCardFeeLineProps {
	lineItem: IPriceLineItem | null;
	gstLabel: string;
}

function CreditCardFeeLine({ lineItem, gstLabel }: CreditCardFeeLineProps) {
	if (lineItem === null) {
		return null;
	}

	return (
		<CartCalculationLineItem
			keyToUse="credit-card-surcharge-line-item"
			className="credit-card-surcharge-line-item"
			lineItemDisplayName="Card fees"
			// lineItemDescription={whiteLabelStore.config.gstPercentage > 0 ? `Including ${gstLabel}` : undefined}
			lineItemPrice={formatPriceDisplay(lineItem.price, true, true, true)}
		/>
	);
}

export default observer(CreditCardFeeLine);
